import type {
  MyServiceWorkerAbsenceCreateApiData,
  MyServiceWorkerAbsenceCreateApiResponses,
  MyServiceWorkerAbsenceListApiData,
  MyServiceWorkerAbsenceListApiResponses,
  MyServiceWorkerAbsenceWithdrawApiData,
  MyServiceWorkerAbsenceWithdrawApiResponses,
  ServiceWorkerAbsenceApproveApiData,
  ServiceWorkerAbsenceApproveApiResponses,
  ServiceWorkerAbsenceCreateApiData,
  ServiceWorkerAbsenceCreateApiResponses,
  ServiceWorkerAbsenceDeleteApiData,
  ServiceWorkerAbsenceDeleteApiResponses,
  ServiceWorkerAbsenceGetApiData,
  ServiceWorkerAbsenceGetApiResponses,
  ServiceWorkerAbsenceListApiData,
  ServiceWorkerAbsenceListApiResponses,
  ServiceWorkerAbsenceRejectApiData,
  ServiceWorkerAbsenceRejectApiResponses,
  ServiceWorkerAbsenceRescheduleApiData,
  ServiceWorkerAbsenceRescheduleApiResponses,
  ServiceWorkerAbsenceWithdrawApiData,
  ServiceWorkerAbsenceWithdrawApiResponses,
  ServiceWorkerAddressPairCreateApiData,
  ServiceWorkerAddressPairCreateApiResponses,
  ServiceWorkerAddressPairDeleteApiData,
  ServiceWorkerAddressPairDeleteApiResponses,
  ServiceWorkerAddressPairGetApiData,
  ServiceWorkerAddressPairGetApiResponses,
  ServiceWorkerAddressPairListApiData,
  ServiceWorkerAddressPairListApiResponses,
  ServiceWorkerAddressPairUpdateApiData,
  ServiceWorkerAddressPairUpdateApiResponses,
  ServiceWorkerBulkPatchApiData,
  ServiceWorkerBulkPatchApiResponses,
  ServiceWorkerContractCreateApiData,
  ServiceWorkerContractCreateApiResponses,
  ServiceWorkerContractDeleteApiData,
  ServiceWorkerContractDeleteApiResponses,
  ServiceWorkerContractGetApiData,
  ServiceWorkerContractGetApiResponses,
  ServiceWorkerContractHourlyBonusPatchApiData,
  ServiceWorkerContractHourlyBonusPatchApiResponses,
  ServiceWorkerContractListApiData,
  ServiceWorkerContractListApiResponses,
  ServiceWorkerContractsOverlappingListApiData,
  ServiceWorkerContractsOverlappingListApiResponses,
  ServiceWorkerContractUnpaidTimeRepricePreviewApiData,
  ServiceWorkerContractUnpaidTimeRepricePreviewApiResponses,
  ServiceWorkerContractUpdateApiData,
  ServiceWorkerContractUpdateApiResponses,
  ServiceWorkerCreateApiData,
  ServiceWorkerCreateApiResponses,
  ServiceWorkerDeleteApiData,
  ServiceWorkerDeleteApiResponses,
  ServiceWorkerGetApiData,
  ServiceWorkerGetApiResponses,
  ServiceWorkerListApiData,
  ServiceWorkerListApiResponses,
  ServiceWorkerMinimalListApiData,
  ServiceWorkerMinimalListApiResponses,
  ServiceWorkerRoutePriorityListApiData,
  ServiceWorkerRoutePriorityListApiResponses,
  ServiceWorkerUpdateApiData,
  ServiceWorkerUpdateApiResponses,
  SkillCreateApiData,
  SkillCreateApiResponses,
  SkillDeleteApiData,
  SkillDeleteApiResponses,
  SkillGetApiData,
  SkillGetApiResponses,
  SkillListApiData,
  SkillListApiResponses,
  SkillPatchApiData,
  SkillPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';
import { serviceWorkerSmsUrls } from './serviceWorkerSmsUrls';
import { workerMessageUrls } from './workerMessageUrls';

export const getWorkerUrls = {
  ...serviceWorkerSmsUrls,
  ...workerMessageUrls,
  getServiceWorkerMinimalList: dataEndpoint<ServiceWorkerMinimalListApiData, ServiceWorkerMinimalListApiResponses>({
    getUrl: (queryParams) => apiUrl('service-workers/minimal/', queryParams)
  }),
  getPaginatedServiceWorkers: dataEndpoint<ServiceWorkerListApiData, ServiceWorkerListApiResponses>({
    getUrl: (queryParams) => apiUrl('service-workers/', queryParams)
  }),
  getWorker: dataEndpoint<ServiceWorkerGetApiData, ServiceWorkerGetApiResponses>({
    getUrl: ({ serviceWorkerId, ...queryParams }) => apiUrl(`service-workers/${serviceWorkerId}/`, queryParams)
  }),
  patchWorker: responseEndpoint<ServiceWorkerUpdateApiData, ServiceWorkerUpdateApiResponses>({
    getUrl: ({ serviceWorkerId }) => apiUrl(`service-workers/${serviceWorkerId}/`),
    getBody: (data) => data
  }),
  postCreateWorker: responseEndpoint<ServiceWorkerCreateApiData, ServiceWorkerCreateApiResponses>({
    getUrl: () => apiUrl('service-workers/'),
    getBody: (data) => data
  }),
  postCreateWorkerFromExistingUser: responseEndpoint<ServiceWorkerCreateApiData, ServiceWorkerCreateApiResponses>({
    getUrl: () => apiUrl('service-workers/'),
    getBody: (data) => data
  }),
  getPaginatedWorkerContracts: dataEndpoint<ServiceWorkerContractListApiData, ServiceWorkerContractListApiResponses>({
    getUrl: ({ serviceDepartmentId, ...rest }) =>
      apiUrl(`service-departments/${serviceDepartmentId}/service-worker-contracts/`, rest)
  }),
  getWorkerContract: dataEndpoint<ServiceWorkerContractGetApiData, ServiceWorkerContractGetApiResponses>({
    getUrl: ({ serviceWorkerContractId }) => apiUrl(`service-worker-contracts/${serviceWorkerContractId}/`)
  }),
  postWorkerContract: responseEndpoint<ServiceWorkerContractCreateApiData, ServiceWorkerContractCreateApiResponses>({
    getUrl: () => apiUrl('service-worker-contracts/'),
    getBody: (data) => data
  }),
  patchWorkerContract: responseEndpoint<ServiceWorkerContractUpdateApiData, ServiceWorkerContractUpdateApiResponses>({
    getUrl: ({ serviceWorkerContractId }) => apiUrl(`service-worker-contracts/${serviceWorkerContractId}/`),
    getBody: (data) => data
  }),
  patchWorkerContractsHourlyBonus: responseEndpoint<
    ServiceWorkerContractHourlyBonusPatchApiData,
    ServiceWorkerContractHourlyBonusPatchApiResponses
  >({
    getUrl: () => apiUrl('service-worker-contracts/hourly-bonus/'),
    getBody: (data) => data
  }),
  getWorkerContractUnpaidTimeRepricePreview: dataEndpoint<
    ServiceWorkerContractUnpaidTimeRepricePreviewApiData,
    ServiceWorkerContractUnpaidTimeRepricePreviewApiResponses
  >({
    getUrl: ({ serviceWorkerContractId, ...queryParams }) =>
      apiUrl(`service-worker-contracts/${serviceWorkerContractId}/unpaid-time-reprice-preview/`, queryParams)
  }),
  deleteWorkerContract: dataEndpoint<ServiceWorkerContractDeleteApiData, ServiceWorkerContractDeleteApiResponses>({
    getUrl: ({ serviceWorkerContractId }) => apiUrl(`service-worker-contracts/${serviceWorkerContractId}/`)
  }),
  getWorkerContractAddressPairs: dataEndpoint<
    ServiceWorkerAddressPairListApiData,
    ServiceWorkerAddressPairListApiResponses
  >({
    getUrl: ({ serviceWorkerContractId }) =>
      apiUrl(`service-worker-contracts/${serviceWorkerContractId}/address-pairs/`)
  }),
  postWorkerContractAddressPair: responseEndpoint<
    ServiceWorkerAddressPairCreateApiData,
    ServiceWorkerAddressPairCreateApiResponses
  >({
    getUrl: ({ serviceWorkerContractId }) =>
      apiUrl(`service-worker-contracts/${serviceWorkerContractId}/address-pairs/`),
    getBody: ({ serviceWorkerContractId: _, ...body }) => body
  }),
  getServiceWorkerAddressPair: dataEndpoint<
    ServiceWorkerAddressPairGetApiData,
    ServiceWorkerAddressPairGetApiResponses
  >({
    getUrl: ({ serviceWorkerAddressPairId }) => apiUrl(`service-worker-address-pairs/${serviceWorkerAddressPairId}/`)
  }),
  patchServiceWorkerAddressPair: responseEndpoint<
    ServiceWorkerAddressPairUpdateApiData,
    ServiceWorkerAddressPairUpdateApiResponses
  >({
    getUrl: ({ serviceWorkerAddressPairId }) => apiUrl(`service-worker-address-pairs/${serviceWorkerAddressPairId}/`),
    getBody: (data) => data
  }),
  patchBulkServiceWorkers: responseEndpoint<ServiceWorkerBulkPatchApiData, ServiceWorkerBulkPatchApiResponses>({
    getUrl: () => apiUrl('service-workers/'),
    getBody: (data) => data
  }),
  deleteServiceWorker: dataEndpoint<ServiceWorkerDeleteApiData, ServiceWorkerDeleteApiResponses>({
    getUrl: ({ serviceWorkerId }) => apiUrl(`service-workers/${serviceWorkerId}/`)
  }),
  deleteServiceWorkerAddressPair: dataEndpoint<
    ServiceWorkerAddressPairDeleteApiData,
    ServiceWorkerAddressPairDeleteApiResponses
  >({
    getUrl: ({ serviceWorkerAddressPairId }) => apiUrl(`service-worker-address-pairs/${serviceWorkerAddressPairId}/`)
  }),
  getServiceWorkerPriorities: dataEndpoint<
    ServiceWorkerRoutePriorityListApiData,
    ServiceWorkerRoutePriorityListApiResponses
  >({
    getUrl: () => apiUrl('route-planner/service-worker-priorities/')
  }),
  getServiceWorkerAbsences: dataEndpoint<ServiceWorkerAbsenceListApiData, ServiceWorkerAbsenceListApiResponses>({
    getUrl: (queryParams) => apiUrl('service-worker-absences/', queryParams)
  }),
  getServiceWorkerAbsence: dataEndpoint<ServiceWorkerAbsenceGetApiData, ServiceWorkerAbsenceGetApiResponses>({
    getUrl: ({ serviceWorkerAbsenceId }) => apiUrl(`service-worker-absences/${serviceWorkerAbsenceId}/`)
  }),
  postServiceWorkerAbsence: responseEndpoint<ServiceWorkerAbsenceCreateApiData, ServiceWorkerAbsenceCreateApiResponses>(
    {
      getUrl: () => apiUrl('service-worker-absences/'),
      getBody: (data) => data
    }
  ),
  patchServiceWorkerAbsenceApprove: responseEndpoint<
    ServiceWorkerAbsenceApproveApiData,
    ServiceWorkerAbsenceApproveApiResponses
  >({
    getUrl: ({ serviceWorkerAbsenceId }) => apiUrl(`service-worker-absences/${serviceWorkerAbsenceId}/approve/`),
    getBody: (data) => data
  }),
  patchServiceWorkerAbsenceReject: responseEndpoint<
    ServiceWorkerAbsenceRejectApiData,
    ServiceWorkerAbsenceRejectApiResponses
  >({
    getUrl: ({ serviceWorkerAbsenceId }) => apiUrl(`service-worker-absences/${serviceWorkerAbsenceId}/reject/`),
    getBody: (data) => data
  }),
  patchServiceWorkerAbsenceReschedule: responseEndpoint<
    ServiceWorkerAbsenceRescheduleApiData,
    ServiceWorkerAbsenceRescheduleApiResponses
  >({
    getUrl: ({ serviceWorkerAbsenceId }) => apiUrl(`service-worker-absences/${serviceWorkerAbsenceId}/reschedule/`),
    getBody: (data) => data
  }),
  patchServiceWorkerAbsenceWithdraw: responseEndpoint<
    ServiceWorkerAbsenceWithdrawApiData,
    ServiceWorkerAbsenceWithdrawApiResponses
  >({
    getUrl: ({ serviceWorkerAbsenceId }) => apiUrl(`service-worker-absences/${serviceWorkerAbsenceId}/withdraw/`)
  }),
  deleteServiceWorkerAbsence: dataEndpoint<ServiceWorkerAbsenceDeleteApiData, ServiceWorkerAbsenceDeleteApiResponses>({
    getUrl: ({ serviceWorkerAbsenceId }) => apiUrl(`service-worker-absences/${serviceWorkerAbsenceId}/`)
  }),
  getMyServiceWorkerAbsences: dataEndpoint<MyServiceWorkerAbsenceListApiData, MyServiceWorkerAbsenceListApiResponses>({
    getUrl: (queryParams) => apiUrl('service-workers/me/absences/', queryParams)
  }),
  postMyServiceWorkerAbsence: responseEndpoint<
    MyServiceWorkerAbsenceCreateApiData,
    MyServiceWorkerAbsenceCreateApiResponses
  >({
    getUrl: () => apiUrl('service-workers/me/absences/'),
    getBody: (data) => data
  }),
  patchMyServiceWorkerAbsenceWithdraw: responseEndpoint<
    MyServiceWorkerAbsenceWithdrawApiData,
    MyServiceWorkerAbsenceWithdrawApiResponses
  >({
    getUrl: ({ serviceWorkerAbsenceId }) => apiUrl(`service-workers/me/absences/${serviceWorkerAbsenceId}/withdraw/`)
  }),
  getServiceWorkerContractsOverlapping: dataEndpoint<
    ServiceWorkerContractsOverlappingListApiData,
    ServiceWorkerContractsOverlappingListApiResponses
  >({
    getUrl: ({ serviceWorkerId, ...queryParams }) =>
      apiUrl(`service-workers/${serviceWorkerId}/contracts-overlapping/`, queryParams)
  }),
  getPaginatedSkills: dataEndpoint<SkillListApiData, SkillListApiResponses>({
    getUrl: (queryParams) => apiUrl('skills/', queryParams)
  }),
  getSkill: dataEndpoint<SkillGetApiData, SkillGetApiResponses>({
    getUrl: ({ skillId }) => apiUrl(`skills/${skillId}/`)
  }),
  postSkill: responseEndpoint<SkillCreateApiData, SkillCreateApiResponses>({
    getUrl: () => apiUrl('skills/'),
    getBody: (data) => data
  }),
  patchSkill: responseEndpoint<SkillPatchApiData, SkillPatchApiResponses>({
    getUrl: ({ skillId }) => apiUrl(`skills/${skillId}/`),
    getBody: (data) => data
  }),
  deleteSkill: dataEndpoint<SkillDeleteApiData, SkillDeleteApiResponses>({
    getUrl: ({ skillId }) => apiUrl(`skills/${skillId}/`)
  })
};
